export default "__VITE_ASSET__uzCTWY6V__"